import { render } from "./OpenOfficeExportModal.vue?vue&type=template&id=12e20eb8&scoped=true"
import script from "./OpenOfficeExportModal.vue?vue&type=script&lang=js"
export * from "./OpenOfficeExportModal.vue?vue&type=script&lang=js"

import "./OpenOfficeExportModal.vue?vue&type=style&index=0&id=12e20eb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e20eb8"]])

export default __exports__